import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/fieldReportBlocks/${number | ':fieldReportBlockId'}/fields`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/fieldReportBlocks/:fieldReportBlockId/fields`;

export const URL = (fieldReportId: number, fieldReportBlockId: number): RouteDefinition =>
	`${baseRoute}/${fieldReportId}/fieldReportBlocks/${fieldReportBlockId}/fields`;
